

export function Format() {

    function format(value = 'init.init',change=false) {
           let formatMoney = typeof value ==="number" ?  parseFloat(value): change ? value.replace(/\D/g, ''): value
           formatMoney= change ? formatMoney/100: formatMoney
           const money = Number(formatMoney).toLocaleString('pt-BR',{
               currency:'BRL',
               style:'currency'
           }).split('R$')[1]
           return money           
    }

    return {
        format
    }
}